// ! This file was auto-generated from the managed-entities OpenAPI schema. Do not override this file.
import { Tags } from "./tags.autogen";
export const endpoints = {
    addAliases: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.EntityAlias, id: arg.entityTypeId }]
    },
    batchAddEntityTypeFields: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.EntityTypeField, id: "LIST" }, { type: Tags.EntityType, id: "LIST" }]
    },
    batchAddGroups: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Group, id: "LIST" }]
    },
    batchAddNodes: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Node, id: "LIST" }]
    },
    batchMoveNodes: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Node, id: "LIST" }]
    },
    batchSetFieldValues: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.EntityFieldValue, id: "LIST" }, { type: Tags.Group, id: arg.groupId }, { type: Tags.Group, id: "LIST" }]
    },
    createEntityType: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.EntityType, id: "LIST" }]
    },
    createGroup: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Group, id: "LIST" }]
    },
    deleteAliases: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.EntityAlias, id: arg.entityTypeId }]
    },
    deleteAllFieldValues: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.EntityFieldValue, id: "LIST" }, { type: Tags.Group, id: arg.groupId }, { type: Tags.Group, id: "LIST" }]
    },
    deleteEntityType: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.EntityType, id: arg.entityTypeId }, { type: Tags.EntityType, id: "LIST" }]
    },
    deleteGroup: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Group, id: arg.groupId }, { type: Tags.Group, id: "LIST" }]
    },
    deleteNode: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Node, id: arg.nodeId }, { type: Tags.Node, id: "LIST" }]
    },
    getEntityType: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.EntityType, id: arg.entityTypeId }]
    },
    getGroup: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Group, id: arg.groupId }]
    },
    getNodePath: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Node, id: "LIST" }]
    },
    listEntityTypeFields: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.EntityTypeField, id: "LIST" }]
    },
    listEntityTypes: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.EntityType, id: "LIST" }]
    },
    listFieldValues: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.EntityFieldValue, id: "LIST" }]
    },
    listGroups: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Group, id: "LIST" }]
    },
    listNodes: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Node, id: "LIST" }]
    },
    mergeAliases: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.EntityAlias, id: arg.entityTypeId }]
    },
    removeEntityTypeField: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.EntityTypeField, id: "LIST" }, { type: Tags.EntityType, id: "LIST" }]
    },
    triggerDiscover: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.EntityType, id: "LIST" }]
    },
    updateEntityType: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.EntityType, id: arg.entityTypeId }, { type: Tags.EntityType, id: "LIST" }]
    },
    updateGroup: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Group, id: arg.groupId }, { type: Tags.Group, id: "LIST" }]
    },
    updateNodeMetadata: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Node, id: arg.nodeId }, { type: Tags.Node, id: "LIST" }]
    }
} as const;
